import type { RouteRecordRaw } from 'vue-router'
import router from '@/router'
import { createWalletManageRoute } from '@/views/dashboard/wallet_manage/WalletManage.vue'

export const manageWalletRoute = (params: {
  name: string
  path?: string
  onSelectRoute: (name: string, walletId: string) => void
}): RouteRecordRaw => {
  return {
    name: params.name,
    path: params.path ?? 'manage',
    component: createWalletManageRoute(params.onSelectRoute),
    props: true,
  }
}
export const walletManageRoute = manageWalletRoute({
  name: 'wallet_manage',
  onSelectRoute(name, walletId) {
    router.replace({
      name,
      params: {
        walletId,
      },
    })
  },
})

export const changeWalletLabelViewRoute = (
  name: string,
  path?: string,
): RouteRecordRaw => {
  return {
    name,
    path: path ?? 'change/label',
    component: () =>
      import('@/views/dashboard/wallet_manage/ChangeWalletLabel.vue'),
    props: true,
  }
}
